import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTemHarcamaAramaComponent} from './ctl-tem-harcama-arama/ctl-tem-harcama-arama.component';
import {TemHarcamaService} from './ctl-tem-harcama.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-tem-harcama',
  templateUrl: './ctl-tem-harcama.component.html',
  styleUrls: ['./ctl-tem-harcama.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemHarcamaAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TemHarcamaService],
})
export class CtlTemHarcamaComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  public control!: any;
  @Input() controlName = "vStsHarcamaTalimatDetay";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: any;
  @Input() period!: number;
  @Input() kurumsalKod: string;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TemHarcamaService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period, this.kurumsalKod,this.isReadOnly,this.isBindCheck)
      }
    }
        if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period, this.kurumsalKod,this.isReadOnly,this.isBindCheck)
          }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Tem Harcama)"
      this.showAction = false
    }
        this.service.setParams(this.period, this.kurumsalKod,this.isReadOnly,this.isBindCheck)
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;

        }
      });
  }

  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData( code,this.control, this.period,this.kurumsalKod, this.control.dlistMetadata.baseEntity,isSetData, this.control.valueField);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0][this.control.descriptionField];
        this.code = result[0][this.control.valueField];
        this.dataResult.emit(result[0]);
      } else {
        this.utilsService.showError('İlgili Yıla Ait Harcama Verisi Yok! HarcamaKod Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst = true
      this.data = result.data;
      this.title = result.data[this.control.descriptionField];
      this.code = result.data[this.control.valueField];
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

}
